export default "__VITE_ASSET__BU_JI2hS__"